"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userProfile_en_us = void 0;
function userProfile_en_us() {
    return {
        "user.profile.firstname": "First Name",
        "user.profile.lastname": "Last Name",
        "user.sso.mergeinstead": "Please merge your accounts instead. Login with your current authentication method, go to your profile and merge your accounts there.",
        "user.login.errors.invalidtoken": "Your credentials are outdated or invalid. You will be logged out now."
    };
}
exports.userProfile_en_us = userProfile_en_us;
